export default __webpack_public_path__ + "static/media/power_industrie.76cd67eb.jpg";